import Flex from 'UIKit/Box/Flex'
import Skeleton from 'UIKit/Skeleton'
import Text from 'UIKit/Text'
import TransText from 'UIKit/Text/TransText'
import { RowBetween } from 'layout/Components/Row'
import React from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { Icons } from 'svgs'
import { colors } from 'theme/colors'
import { CardSection } from 'views/Tournament'

const EligibelGameLoaders = () => {
  return (
    <CardSection>
      <RowBetween>
        <TransText color="textTertiary" fontSize="14px" fontWeight={700} lineHeight="22px" letterSpacing="-0.28px">
          Eligible List game
        </TransText>
        <StyledTextButton alignItems="center" onClick={() => {}}>
          <Text mr="5px" fontSize="12px" color="textSubtle">
            <Trans>View list</Trans>
          </Text>
          <Icons.ChevronRightIcon width="4.5px" fill={colors.textDisable} />
        </StyledTextButton>
      </RowBetween>

      <Text
        color="textAlt1"
        fontSize="12px"
        fontWeight={400}
        letterSpacing={-0.24}
        my="8px"
        mb="12px"
        style={{ wordBreak: 'break-all' }}
      >
        <Trans>Please choose a desirable game to join Tourament.</Trans>
      </Text>

      <>
        <Skeleton />
        <Skeleton my={'4px'} />
        <Skeleton my={'4px'} />
        <Skeleton />
      </>
    </CardSection>
  )
}

const StyledTextButton = styled(Flex)`
  cursor: pointer;
  align-items: center;

  svg {
    fill: ${({ theme }) => theme.colors.textAlt1};
  }

  &:hover {
    ${Text} {
      color: ${({ theme }) => theme.colors.text} !important;
    }

    svg {
      fill: ${({ theme }) => theme.colors.text};
    }
  }
`

export default React.memo(EligibelGameLoaders)
